(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-category-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('.wc-caps [data-wc-system]');
  if (!button) return;

  const root = button.closest('.wc-caps');
  const system = button.dataset.wcSystem;
  const label = button.dataset.wcSystemLabel || 'Избраната система';
  const results = root.querySelector('[data-wc-caps-results]');
  if (!results) return;

  let visible = 0;

  root.querySelectorAll('[data-wc-system]').forEach(function(item) {
    item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
  });

  root.querySelectorAll('[data-wc-caps-product]').forEach(function(card) {
    const matches = card.dataset.system === system;
    card.hidden = !matches;
    if (matches) visible += 1;
  });

  const title = root.querySelector('[data-wc-system-title]');
  const summary = root.querySelector('[data-wc-system-summary]');
  const empty = root.querySelector('[data-wc-system-empty]');

  if (title) title.textContent = label;
  if (summary) {
    summary.textContent = visible === 1
      ? '1 съвместим продукт.'
      : visible + ' съвместими продукта.';
  }
  if (empty) empty.hidden = visible !== 0;

  results.hidden = false;
  results.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-global-desktop-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWaddoGlobalHeader(root) {
      var scope = root || document;

      scope.querySelectorAll('[data-waddo-global-header]').forEach(function (section) {
        if (section.dataset.wghReady === 'true') return;
        section.dataset.wghReady = 'true';

        var dropdown = section.querySelector('[data-wgh-coffee-menu]');
        if (!dropdown) return;

        section.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && dropdown.open) {
            dropdown.open = false;
            var summary = dropdown.querySelector('summary');
            if (summary) summary.focus();
          }
        });

        document.addEventListener('click', function (event) {
          if (dropdown.open && !dropdown.contains(event.target)) {
            dropdown.open = false;
          }
        });
      });
    }

    initWaddoGlobalHeader(document);
    document.addEventListener('shopify:section:load', function (event) {
      initWaddoGlobalHeader(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-global-mobile-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWaddoGlobalMobileHeader(root) {
      var scope = root || document;

      scope.querySelectorAll('[data-waddo-global-mobile-header]').forEach(function (section) {
        if (section.dataset.wgmReady === 'true') return;
        section.dataset.wgmReady = 'true';

        var header = section.querySelector('.wgm-header');
        var toggle = section.querySelector('[data-wgm-menu-toggle]');
        var nav = section.querySelector('[data-wgm-main-nav]');
        if (!header || !toggle || !nav) return;

        function setOpen(open) {
          header.classList.toggle('is-menu-open', open);
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) nav.scrollTop = 0;
          else {
            var submenu = header.querySelector('[data-wgm-coffee-menu]');
            if (submenu) submenu.open = false;
          }
        }

        toggle.addEventListener('click', function () {
          setOpen(toggle.getAttribute('aria-expanded') !== 'true');
        });

        nav.querySelectorAll('a').forEach(function (link) {
          link.addEventListener('click', function () {
            setOpen(false);
          });
        });

        document.addEventListener('pointerdown', function (event) {
          if (toggle.getAttribute('aria-expanded') === 'true' && !header.contains(event.target)) setOpen(false);
        });

        header.addEventListener('keydown', function (event) {
          var coffeeMenu = header.querySelector('[data-wgm-coffee-menu]');

          if (event.key === 'Escape' && coffeeMenu && coffeeMenu.open) {
            coffeeMenu.open = false;
            var summary = coffeeMenu.querySelector('summary');
            if (summary) summary.focus();
            event.stopPropagation();
            return;
          }

          if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
            setOpen(false);
            toggle.focus();
          }
        });
      });
    }

    initWaddoGlobalMobileHeader(document);
    document.addEventListener('shopify:section:load', function (event) {
      initWaddoGlobalMobileHeader(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-home-bak-0922"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWaddoMobileMenu(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-mobile-header]').forEach(function (header) {
      if (header.dataset.w2MenuReady === 'true') return;
      header.dataset.w2MenuReady = 'true';

      var toggle = header.querySelector('[data-w2-menu-toggle]');
      var nav = header.querySelector('[data-w2-main-nav]');
      if (!toggle || !nav) return;

      function setOpen(open) {
        header.classList.toggle('is-menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });

      header.addEventListener('keydown', function (event) {
        var coffeeMenu = header.querySelector('[data-w2-coffee-menu]');
        if (event.key === 'Escape' && coffeeMenu && coffeeMenu.open) {
          coffeeMenu.open = false;
          var summary = coffeeMenu.querySelector('summary');
          if (summary) summary.focus();
          event.stopPropagation();
          return;
        }
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  function initWaddoProductCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-product-carousel]').forEach(function (carousel) {
      if (carousel.dataset.w2Ready === 'true') return;
      carousel.dataset.w2Ready = 'true';

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-dot]'));
      var prev = carousel.querySelector('[data-w2-product-prev]');
      var next = carousel.querySelector('[data-w2-product-next]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      var startX = null;

      function show(target) {
        index = (target + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (reducedMotion || slides.length < 2) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, 6500);
      }

      if (prev) prev.addEventListener('click', function () {
        show(index - 1);
        start();
      });
      if (next) next.addEventListener('click', function () {
        show(index + 1);
        start();
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-w2-product-dot')));
          start();
        });
      });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', function (event) {
        if (!carousel.contains(event.relatedTarget)) start();
      });
      carousel.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
      });
      carousel.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        show(delta < 0 ? index + 1 : index - 1);
        start();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      show(0);
      start();
    });
  }

  initWaddoMobileMenu(document);
  initWaddoProductCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    initWaddoMobileMenu(event.target);
    initWaddoProductCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-home-bak-211a"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWaddoMobileMenu(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-mobile-header]').forEach(function (header) {
      if (header.dataset.w2MenuReady === 'true') return;
      header.dataset.w2MenuReady = 'true';

      var toggle = header.querySelector('[data-w2-menu-toggle]');
      var nav = header.querySelector('[data-w2-main-nav]');
      if (!toggle || !nav) return;

      function setOpen(open) {
        header.classList.toggle('is-menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });

      header.addEventListener('keydown', function (event) {
        var coffeeMenu = header.querySelector('[data-w2-coffee-menu]');
        if (event.key === 'Escape' && coffeeMenu && coffeeMenu.open) {
          coffeeMenu.open = false;
          var summary = coffeeMenu.querySelector('summary');
          if (summary) summary.focus();
          event.stopPropagation();
          return;
        }
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  function initWaddoProductCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-product-carousel]').forEach(function (carousel) {
      if (carousel.dataset.w2Ready === 'true') return;
      carousel.dataset.w2Ready = 'true';

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-dot]'));
      var prev = carousel.querySelector('[data-w2-product-prev]');
      var next = carousel.querySelector('[data-w2-product-next]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      var startX = null;

      function show(target) {
        index = (target + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (reducedMotion || slides.length < 2) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, 6500);
      }

      if (prev) prev.addEventListener('click', function () {
        show(index - 1);
        start();
      });
      if (next) next.addEventListener('click', function () {
        show(index + 1);
        start();
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-w2-product-dot')));
          start();
        });
      });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', function (event) {
        if (!carousel.contains(event.relatedTarget)) start();
      });
      carousel.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
      });
      carousel.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        show(delta < 0 ? index + 1 : index - 1);
        start();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      show(0);
      start();
    });
  }

  initWaddoMobileMenu(document);
  initWaddoProductCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    initWaddoMobileMenu(event.target);
    initWaddoProductCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-home-bak-212a"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWaddoMobileMenu(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-mobile-header]').forEach(function (header) {
      if (header.dataset.w2MenuReady === 'true') return;
      header.dataset.w2MenuReady = 'true';

      var toggle = header.querySelector('[data-w2-menu-toggle]');
      var nav = header.querySelector('[data-w2-main-nav]');
      if (!toggle || !nav) return;

      function setOpen(open) {
        header.classList.toggle('is-menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });

      header.addEventListener('keydown', function (event) {
        var coffeeMenu = header.querySelector('[data-w2-coffee-menu]');
        if (event.key === 'Escape' && coffeeMenu && coffeeMenu.open) {
          coffeeMenu.open = false;
          var summary = coffeeMenu.querySelector('summary');
          if (summary) summary.focus();
          event.stopPropagation();
          return;
        }
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  function initWaddoProductCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-product-carousel]').forEach(function (carousel) {
      if (carousel.dataset.w2Ready === 'true') return;
      carousel.dataset.w2Ready = 'true';

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-dot]'));
      var prev = carousel.querySelector('[data-w2-product-prev]');
      var next = carousel.querySelector('[data-w2-product-next]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      var startX = null;

      function show(target) {
        index = (target + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (reducedMotion || slides.length < 2) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, 6500);
      }

      if (prev) prev.addEventListener('click', function () {
        show(index - 1);
        start();
      });
      if (next) next.addEventListener('click', function () {
        show(index + 1);
        start();
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-w2-product-dot')));
          start();
        });
      });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', function (event) {
        if (!carousel.contains(event.relatedTarget)) start();
      });
      carousel.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
      });
      carousel.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        show(delta < 0 ? index + 1 : index - 1);
        start();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      show(0);
      start();
    });
  }

  initWaddoMobileMenu(document);
  initWaddoProductCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    initWaddoMobileMenu(event.target);
    initWaddoProductCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-home-bak-212g"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWaddoMobileMenu(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-mobile-header]').forEach(function (header) {
      if (header.dataset.w2MenuReady === 'true') return;
      header.dataset.w2MenuReady = 'true';

      var toggle = header.querySelector('[data-w2-menu-toggle]');
      var nav = header.querySelector('[data-w2-main-nav]');
      if (!toggle || !nav) return;

      function setOpen(open) {
        header.classList.toggle('is-menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });

      header.addEventListener('keydown', function (event) {
        var coffeeMenu = header.querySelector('[data-w2-coffee-menu]');
        if (event.key === 'Escape' && coffeeMenu && coffeeMenu.open) {
          coffeeMenu.open = false;
          var summary = coffeeMenu.querySelector('summary');
          if (summary) summary.focus();
          event.stopPropagation();
          return;
        }
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  function initWaddoProductCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-product-carousel]').forEach(function (carousel) {
      if (carousel.dataset.w2Ready === 'true') return;
      carousel.dataset.w2Ready = 'true';

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-dot]'));
      var prev = carousel.querySelector('[data-w2-product-prev]');
      var next = carousel.querySelector('[data-w2-product-next]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      var startX = null;

      function show(target) {
        index = (target + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (reducedMotion || slides.length < 2) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, 6500);
      }

      if (prev) prev.addEventListener('click', function () {
        show(index - 1);
        start();
      });
      if (next) next.addEventListener('click', function () {
        show(index + 1);
        start();
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-w2-product-dot')));
          start();
        });
      });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', function (event) {
        if (!carousel.contains(event.relatedTarget)) start();
      });
      carousel.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
      });
      carousel.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        show(delta < 0 ? index + 1 : index - 1);
        start();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      show(0);
      start();
    });
  }

  initWaddoMobileMenu(document);
  initWaddoProductCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    initWaddoMobileMenu(event.target);
    initWaddoProductCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-home-bak-beansfill"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWaddoMobileMenu(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-mobile-header]').forEach(function (header) {
      if (header.dataset.w2MenuReady === 'true') return;
      header.dataset.w2MenuReady = 'true';

      var toggle = header.querySelector('[data-w2-menu-toggle]');
      var nav = header.querySelector('[data-w2-main-nav]');
      if (!toggle || !nav) return;

      function setOpen(open) {
        header.classList.toggle('is-menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });

      header.addEventListener('keydown', function (event) {
        var coffeeMenu = header.querySelector('[data-w2-coffee-menu]');
        if (event.key === 'Escape' && coffeeMenu && coffeeMenu.open) {
          coffeeMenu.open = false;
          var summary = coffeeMenu.querySelector('summary');
          if (summary) summary.focus();
          event.stopPropagation();
          return;
        }
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  function initWaddoProductCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-product-carousel]').forEach(function (carousel) {
      if (carousel.dataset.w2Ready === 'true') return;
      carousel.dataset.w2Ready = 'true';

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-dot]'));
      var prev = carousel.querySelector('[data-w2-product-prev]');
      var next = carousel.querySelector('[data-w2-product-next]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      var startX = null;

      function show(target) {
        index = (target + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (reducedMotion || slides.length < 2) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, 6500);
      }

      if (prev) prev.addEventListener('click', function () {
        show(index - 1);
        start();
      });
      if (next) next.addEventListener('click', function () {
        show(index + 1);
        start();
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-w2-product-dot')));
          start();
        });
      });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', function (event) {
        if (!carousel.contains(event.relatedTarget)) start();
      });
      carousel.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
      });
      carousel.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        show(delta < 0 ? index + 1 : index - 1);
        start();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      show(0);
      start();
    });
  }

  initWaddoMobileMenu(document);
  initWaddoProductCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    initWaddoMobileMenu(event.target);
    initWaddoProductCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-home-bak-bg"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWaddoMobileMenu(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-mobile-header]').forEach(function (header) {
      if (header.dataset.w2MenuReady === 'true') return;
      header.dataset.w2MenuReady = 'true';

      var toggle = header.querySelector('[data-w2-menu-toggle]');
      var nav = header.querySelector('[data-w2-main-nav]');
      if (!toggle || !nav) return;

      function setOpen(open) {
        header.classList.toggle('is-menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });

      header.addEventListener('keydown', function (event) {
        var coffeeMenu = header.querySelector('[data-w2-coffee-menu]');
        if (event.key === 'Escape' && coffeeMenu && coffeeMenu.open) {
          coffeeMenu.open = false;
          var summary = coffeeMenu.querySelector('summary');
          if (summary) summary.focus();
          event.stopPropagation();
          return;
        }
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  function initWaddoProductCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-product-carousel]').forEach(function (carousel) {
      if (carousel.dataset.w2Ready === 'true') return;
      carousel.dataset.w2Ready = 'true';

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-dot]'));
      var prev = carousel.querySelector('[data-w2-product-prev]');
      var next = carousel.querySelector('[data-w2-product-next]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      var startX = null;

      function show(target) {
        index = (target + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (reducedMotion || slides.length < 2) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, 6500);
      }

      if (prev) prev.addEventListener('click', function () {
        show(index - 1);
        start();
      });
      if (next) next.addEventListener('click', function () {
        show(index + 1);
        start();
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-w2-product-dot')));
          start();
        });
      });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', function (event) {
        if (!carousel.contains(event.relatedTarget)) start();
      });
      carousel.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
      });
      carousel.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        show(delta < 0 ? index + 1 : index - 1);
        start();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      show(0);
      start();
    });
  }

  initWaddoMobileMenu(document);
  initWaddoProductCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    initWaddoMobileMenu(event.target);
    initWaddoProductCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-home-bak-groundfill"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWaddoMobileMenu(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-mobile-header]').forEach(function (header) {
      if (header.dataset.w2MenuReady === 'true') return;
      header.dataset.w2MenuReady = 'true';

      var toggle = header.querySelector('[data-w2-menu-toggle]');
      var nav = header.querySelector('[data-w2-main-nav]');
      if (!toggle || !nav) return;

      function setOpen(open) {
        header.classList.toggle('is-menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });

      header.addEventListener('keydown', function (event) {
        var coffeeMenu = header.querySelector('[data-w2-coffee-menu]');
        if (event.key === 'Escape' && coffeeMenu && coffeeMenu.open) {
          coffeeMenu.open = false;
          var summary = coffeeMenu.querySelector('summary');
          if (summary) summary.focus();
          event.stopPropagation();
          return;
        }
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  function initWaddoProductCarousels(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-w2-product-carousel]').forEach(function (carousel) {
      if (carousel.dataset.w2Ready === 'true') return;
      carousel.dataset.w2Ready = 'true';

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-w2-product-dot]'));
      var prev = carousel.querySelector('[data-w2-product-prev]');
      var next = carousel.querySelector('[data-w2-product-next]');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      var startX = null;

      function show(target) {
        index = (target + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (reducedMotion || slides.length < 2) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, 6500);
      }

      if (prev) prev.addEventListener('click', function () {
        show(index - 1);
        start();
      });
      if (next) next.addEventListener('click', function () {
        show(index + 1);
        start();
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-w2-product-dot')));
          start();
        });
      });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', function (event) {
        if (!carousel.contains(event.relatedTarget)) start();
      });
      carousel.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
      });
      carousel.addEventListener('pointerup', function (event) {
        if (startX === null) return;
        var delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) < 45) return;
        show(delta < 0 ? index + 1 : index - 1);
        start();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      show(0);
      start();
    });
  }

  initWaddoMobileMenu(document);
  initWaddoProductCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    initWaddoMobileMenu(event.target);
    initWaddoProductCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-office-10"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.wo10');
  if(!root || root.dataset.ready==='1') return;
  root.dataset.ready='1';
  var packageInput=root.querySelector('[data-office10-package-input]');
  var selected=root.querySelector('[data-office10-selected] strong');
  var selectedBox=root.querySelector('[data-office10-selected]');
  var formSection=root.querySelector('#office10-enquiry');
  root.querySelectorAll('[data-office10-package]').forEach(function(button){
    button.addEventListener('click',function(){
      var variantId=button.getAttribute('data-office10-variant-id');
      if(variantId) return;
      var value=button.getAttribute('data-office10-package')||'';
      if(packageInput) packageInput.value=value;
      if(selected) selected.textContent=value;
      if(selectedBox){
        selectedBox.scrollIntoView({behavior:'smooth',block:'center'});
      }else if(formSection){
        formSection.scrollIntoView({behavior:'smooth',block:'start'});
      }
    });
  });
})();

(function(){
 var root=document.querySelector('.wo10');
 if(!root) return;
 var ids=["office10-beans","office10-ground","office10-capsules"];
 ids.forEach(function(id){
  var card=root.querySelector('#'+id); if(!card) return;
  var button=card.querySelector('[data-office10-package]');
  var details=card.nextElementSibling;
  if(!button || !details || details.tagName!=='DETAILS') return;
  button.textContent='Разгледай вариантите →';
  button.setAttribute('aria-expanded',details.open?'true':'false');
  button.addEventListener('click',function(e){
   e.preventDefault(); e.stopImmediatePropagation(); details.open=true; button.setAttribute('aria-expanded','true'); details.scrollIntoView({behavior:'smooth',block:'start'});
  },true);
 });
})();


/* WADDO OFFICE ROTATING SELECTION V1 */
(function(){
  var root=document.querySelector('.wo10');
  if(!root) return;
  root.querySelectorAll('[data-waddo-office-carousel]').forEach(function(carousel){
    if(carousel.dataset.rotatingReady==='1') return;
    var track=carousel.querySelector('[data-waddo-office-track]');
    if(!track || track.children.length<4) return;
    carousel.dataset.rotatingReady='1';
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.setInterval(function(){
      if(document.hidden) return;
      var first=track.firstElementChild;
      if(!first) return;
      var styles=window.getComputedStyle(track);
      var gap=parseFloat(styles.columnGap || styles.gap || '8') || 8;
      var step=first.getBoundingClientRect().width + gap;
      track.style.transition='transform .55s ease';
      track.style.transform='translateX(-'+step+'px)';
      window.setTimeout(function(){
        track.style.transition='none';
        track.appendChild(first);
        track.style.transform='translateX(0)';
        track.offsetHeight;
      },560);
    },6000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waddo-office-5"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.wo5');
  if(!root || root.dataset.ready==='1') return;
  root.dataset.ready='1';
  var packageInput=root.querySelector('[data-office5-package-input]');
  var selected=root.querySelector('[data-office5-selected] strong');
  var selectedBox=root.querySelector('[data-office5-selected]');
  var formSection=root.querySelector('#office5-enquiry');
  root.querySelectorAll('[data-office5-package]').forEach(function(button){
    button.addEventListener('click',function(){
      var variantId=button.getAttribute('data-office5-variant-id');
      if(variantId) return;
      var value=button.getAttribute('data-office5-package')||'';
      if(packageInput) packageInput.value=value;
      if(selected) selected.textContent=value;
      if(selectedBox){
        selectedBox.scrollIntoView({behavior:'smooth',block:'center'});
      }else if(formSection){
        formSection.scrollIntoView({behavior:'smooth',block:'start'});
      }
    });
  });
})();

(function(){
 var root=document.querySelector('.wo5');
 if(!root) return;
 var ids=["office5-beans","office5-ground","office5-capsules"];
 ids.forEach(function(id){
  var card=root.querySelector('#'+id); if(!card) return;
  var button=card.querySelector('[data-office5-package]');
  var details=card.nextElementSibling;
  if(!button || !details || details.tagName!=='DETAILS') return;
  button.textContent='Разгледай вариантите →';
  button.setAttribute('aria-expanded',details.open?'true':'false');
  button.addEventListener('click',function(e){
   e.preventDefault(); e.stopImmediatePropagation(); details.open=true; button.setAttribute('aria-expanded','true'); details.scrollIntoView({behavior:'smooth',block:'start'});
  },true);
 });
})();


/* WADDO OFFICE ROTATING SELECTION V1 */
(function(){
  var root=document.querySelector('.wo5');
  if(!root) return;
  root.querySelectorAll('[data-waddo-office-carousel]').forEach(function(carousel){
    if(carousel.dataset.rotatingReady==='1') return;
    var track=carousel.querySelector('[data-waddo-office-track]');
    if(!track || track.children.length<4) return;
    carousel.dataset.rotatingReady='1';
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.setInterval(function(){
      if(document.hidden) return;
      var first=track.firstElementChild;
      if(!first) return;
      var styles=window.getComputedStyle(track);
      var gap=parseFloat(styles.columnGap || styles.gap || '8') || 8;
      var step=first.getBoundingClientRect().width + gap;
      track.style.transition='transform .55s ease';
      track.style.transform='translateX(-'+step+'px)';
      window.setTimeout(function(){
        track.style.transition='none';
        track.appendChild(first);
        track.style.transform='translateX(0)';
        track.offsetHeight;
      },560);
    },6000);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
